<ng-container *ngIf="appComponentData$ | async as appComponentData; else loading">
  <app-topbar />
  <main>
    <router-outlet />
  </main>
  <shared-cookie-disclaimer *ngIf="!cookieDisclaimerService.cookieDisclaimerAgreed()" />
</ng-container>
<ng-template #loading>
  <app-loader></app-loader>
</ng-template>
